<template>
    <div>
        <div class="content">
            <div class="cont-list">
                <span class="list">{{
                    this.route.menuName
                    }}</span>
            </div>
            <div class="header">
                <div class="left">

                    <el-button type="primary" class="btn primary" v-preventReClick @click="uploadBtnEvt">上 传</el-button>
                    <SelectFilter ref="selectFilter" :query="query" :options="filterOptions" @filterChange="filterChange"
                        @reset="reset"></SelectFilter>
                </div>
            </div>
            <el-table ref="multipleTable" border row-key="id" :data="tableData" :max-height="tableHeight"
                style="width: 100%" stripe :header-cell-style="{ background: '#DDEBFF' }">
                <template slot="empty">
                    <div class="empty-div" :style="{ height: tableHeight + 'px' }">
                        <img src="../../../assets/noData.png" width="240" height="240" />
                        <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
                        <div class="empty-rest" @click="reset">恢复默认</div>
                    </div>
                </template>
                <el-table-column label="附件名称" prop="name"></el-table-column>
                <el-table-column label="类型" prop="tabName">
                    <template slot-scope="scope">
                        {{ scope.row.type === 1 ? '财务报表' : '其他' }}
                    </template>
                </el-table-column>
                <el-table-column label="上传时间" prop="createdTime">
                    <template slot-scope="scope">
                        {{ parseTime(new Date(scope.row.createdTime), "{y}-{m}-{d} {h}:{i}:{s}") }}
                    </template>
                </el-table-column>
                <el-table-column label="上传人" prop="createdUserName"></el-table-column>
                <el-table-column prop="operation" label="操作" width="210">
                    <template slot-scope="scope">
                        <el-button  type="text" v-preventReClick @click="previewFile(scope.row)"
                            class="color-blue">预览</el-button>
                        <el-button type="text" v-preventReClick @click="downloadFile(scope.row)"
                            class="color-blue">下载</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <el-dialog title="文件管理" :visible.sync="dialogVisible" width="50%" :showClose="false" :before-close="handleClose">
            <el-form ref="form" :model="form" label-width="80px">
                <el-form-item label="上传类型:">
                    <el-select v-model="form.type" placeholder="请选择上传类型">
                        <el-option label="财务报表" value="1"></el-option>
                    </el-select>
                </el-form-item>
                <el-upload ref="uploadComponent" class="upload-demo" drag :action="uploadAction" multiple :limit="10"
                    :file-list="form.fileList" :auto-upload="false" :on-change="handleChange"
                    :on-preview="openImageViewer" :on-success="handleSuccess" :submit="submitUpload">
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                    <div class="el-upload__tip" slot="tip">
                        <span style="font-weight: 500;">上传限制</span><br>
                        <span>
                            1. 单个文件大小不可超过100M &nbsp;&nbsp;&nbsp;&nbsp;
                            2. 最多一次性可上传10个文件 &nbsp;&nbsp;&nbsp;&nbsp;
                            3. 支持类型：word、excel、pdf、及常用图片类型。
                        </span>
                    </div>
                </el-upload>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button class="btn" @click="dialogVisible = false">取 消</el-button>
                <el-button class="btn primary" type="primary" @click="submitUpload">确 定</el-button>
            </span>
        </el-dialog>
        <el-image-viewer :openViewer="openViewer" :file="viewerFile" :fileId="fileId" :fileName="fileName"
            @closeImageViewer="closeImageViewer" />
    </div>
</template>

<script>
import GetDataMixin from "@/mixin/getData-mixin.js";
import { GetFileManagements, SaveFileManagement } from "@/api";
import SelectFilter from "@/components/table-select-filter";
import ElImageViewer from "@/components/elImageViewer";
export default {
    mixins: [GetDataMixin],
    components: {
        SelectFilter,
        ElImageViewer,
    },
    data() {
        return {
            query: {},
            dialogVisible: false,
            uploadAction: config.FileUploadHost + "/FileInfo/FileUpload", // 推送服务的
            tableData: [],
            form: {
                type: '1',
                fileList: [],
            },
            fileId: 0,
            fileName: "",
            openViewer: false,
            viewerFile: '',
            filterOptions: [
                {
                    name: "附件名称",
                    type: "input",
                    code: "keyWord",
                },
     
                {
                    name: "类型",
                    type: "select",
                    code: "type",
                        data: [{
                            id:1,
                            name:'财务报表'
                        }],
                },

                {
                    name: "上传时间",
                    type: "datetime",
                    code: "createdDate",
                    format: 'yyyy-MM-dd HH:mm:ss',
                    startDateCode: "startTime",
                    endDateCode: "endTime",
                },
                {
                    name: "上传人",
                    type: "input",
                    code: "createdUserName",
                },
            ],
            submitFileList: [],
        };
    },
    methods: {
        // 上传附件
        openImageViewer(e) {
            this.viewerFile = e.raw
            this.fileName = e.name
            this.openViewer = true;
        },
        closeImageViewer() {
            this.openViewer = false;
        },
        reset() {
            this.query = {}
            this.getData()
        },
        getData() {
            GetFileManagements(this.query).then(res => {
                if (res.successful) {
                    this.tableData = res.returnData.data
                }
            })
        },
        uploadBtnEvt() {
            this.dialogVisible = true
        },
        handleClose() {
            this.form = {
                type: '1',
                fileList: [],
            }
        },
        handleSuccess(res, file) {
            this.submitFileList.push(res.returnData[0]);

            if (this.submitFileList.length === this.form.fileList.length) {
                this.saveFilesAfterUpload();
            }
        },

        saveFilesAfterUpload() {
            let data = this.submitFileList.map(item => {
                return {
                    name: item.name,
                    type: this.form.type,
                    fileInfos: [{ ...item }]
                }
            });

            SaveFileManagement(data).then(res => {
                this.loading.close(); // 在保存成功后关闭loading
                this.submitFileList = [];
                this.form = {
                    type: '1',
                    fileList: [],
                };
                this.dialogVisible = false
                this.getData()
            }).catch(error => {
                this.loading.close();
                this.$message.error(`保存文件失败: ${error.message}`);
            });
        },

        submitUpload() {
            if (!this.form.fileList || this.form.fileList.length === 0) {
                this.$message.warning('请选择需要上传的文件');
                return;
            }

            this.loading = this.$loading({
                lock: true,
                text: '文件上传中，请稍候...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            this.submitFileList = [];
            this.$refs.uploadComponent.submit();
        },

        handleChange(file, fileList) {
            this.form.fileList = fileList
        },
        previewFile(row) {
            this.fileId = row.fileInfos[0].id
            this.fileName = row.name
            this.openViewer = true
        },
        downloadFile(row) {
            window.open(config.FileUploadHost + "/FileInfo/FileDownload?fileId=" + row.fileInfos[0].id);
        },
    
    },
    created() {
        this.getData()
    }
};
</script>

<style lang="scss" scoped>
/deep/.el-upload {
    width: 100% !important;
}

/deep/.el-upload-dragger {
    width: 100% !important;
    background: #FBFBFB;
}

/deep/.el-upload-list {
    display: flex;
    flex-wrap: wrap;

    li {
        background: #F8FAFB;
        width: 49%;
        margin-left: 1%;
    }
}
</style>